/**
 * German singular labels for entity types, e.g. for pick-list meta lines.
 */
export const entityTypeLabels: Record<string, string> = {
  Bookmark: 'Ansicht',
  Story: 'Bericht',
  Topic: 'Thema',
  IndicatorData: 'Daten',
  DataLayer: 'Datenebene',
};
